export function toSnakeCase(str: string): string {
    return str
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");
}

export function toCamelCase(str: string): string {
    const snakeCase = toSnakeCase(str);
    return snakeCase.replace(/_+([a-z0-9])/g, (_, char: string) => char.toUpperCase());
}

export function toTitleCase(input: string): string {
  return input
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/[_-]+/g, " ")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (character) => character.toUpperCase());
}
